import { Card, CardTitle, VirtualizedDataTable } from "@tellescope/ui";
import { PermissionWrapper } from "../../PermissionWrapper";
import { useTranslation } from "react-i18next";
import { useTicketQueuesPanel } from "./useTicketQueuesPanel";
import { TicketQueueCreateEditSheet } from "./TicketQueueSheet";

export interface TicketQueuesPanelProps {}

export const TicketQueuesPanel = (_: TicketQueuesPanelProps) => {
  const { t } = useTranslation("ticket-queues");

  const { containerRef, virtualizedTableProps, isCreateEditFormOpen, setIsCreateEditFormOpen, queueIdBeingEdited } =
    useTicketQueuesPanel();

  return (
    <PermissionWrapper model="ticket_queues" action="read">
      <div ref={containerRef}>
        <Card className="p-6">
          <div className="grid gap-1">
            <CardTitle>{t("Ticket Queues")}</CardTitle>
          </div>
          <VirtualizedDataTable {...virtualizedTableProps} tableClassName="border-0 h-min" />
          <TicketQueueCreateEditSheet
            open={isCreateEditFormOpen}
            onOpenChange={setIsCreateEditFormOpen}
            queueId={queueIdBeingEdited}
          />
        </Card>
      </div>
    </PermissionWrapper>
  );
};
